/** Splash HTML (#udv-splash): mínimo visible aunque el bundle monte antes. */
export const SPLASH_MIN_MS = 2500
export const SPLASH_FADE_MS = 450
/** Tope si el ticket/elev cuelga: no dejar el logo infinito. */
export const SPLASH_SHELL_MAX_MS = 10000

let shellGateActive = false
let safetyTimer = null
let hideTimer = null

function splashEl() {
  if (typeof document === 'undefined') return null
  return document.getElementById('udv-splash')
}

export function hideUdvSplash() {
  const el = splashEl()
  if (!el || el.dataset.udvHidden === '1') return
  el.dataset.udvHidden = '1'
  el.classList.add('udv-splash-hide')
  el.setAttribute('aria-busy', 'false')
  setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el)
  }, SPLASH_FADE_MS + 50)
}

/**
 * ¿Hay que esperar shell/theme del ticket/elev/worklist/invite?
 * @param {string|URLSearchParams|null} [search]
 * @param {string} [pathname]
 * @returns {boolean}
 */
export function shouldDeferSplashForShell(search, pathname) {
  let params = null
  if (search && typeof search.get === 'function') {
    params = search
  } else if (typeof search === 'string') {
    params = new URLSearchParams(
      search.startsWith('?') ? search.slice(1) : search
    )
  } else if (typeof window !== 'undefined') {
    params = new URLSearchParams(window.location.search)
  } else {
    return false
  }
  if (params.get('t') || params.get('elev') || params.get('w') || params.get('udvInvite')) {
    return true
  }
  const path =
    pathname != null
      ? String(pathname)
      : typeof window !== 'undefined'
        ? window.location.pathname || ''
        : ''
  // Deep-link /v/Tk_…
  if (/\/v\/Tk_[A-Za-z0-9_-]+/i.test(path)) return true
  return false
}

function clearSafetyTimer() {
  if (safetyTimer != null) {
    clearTimeout(safetyTimer)
    safetyTimer = null
  }
}

/**
 * Bloquea scheduleSplashHide hasta releaseSplashShellGate (o timeout).
 * Idempotente.
 * @param {{ maxMs?: number }} [opts]
 */
export function armSplashUntilShellReady(opts = {}) {
  shellGateActive = true
  clearSafetyTimer()
  const maxMs =
    opts.maxMs != null && Number.isFinite(Number(opts.maxMs))
      ? Math.max(0, Number(opts.maxMs))
      : SPLASH_SHELL_MAX_MS
  safetyTimer = setTimeout(() => {
    safetyTimer = null
    releaseSplashShellGate()
  }, maxMs)
}

/**
 * Permite ocultar el splash (respeta SPLASH_MIN_MS desde T0).
 */
export function releaseSplashShellGate() {
  clearSafetyTimer()
  shellGateActive = false
  scheduleSplashHide({ force: true })
}

/**
 * Oculta el splash cuando pasaron SPLASH_MIN_MS desde T0 y la app React ya montó.
 * Si hay gate activo (ticket pendiente), no-op hasta releaseSplashShellGate.
 * @param {{ force?: boolean }} [opts]
 */
export function scheduleSplashHide(opts = {}) {
  if (shellGateActive && !opts.force) return
  const t0 =
    (typeof window !== 'undefined' && window.__UDV_SPLASH_T0) || Date.now()
  const wait = Math.max(0, SPLASH_MIN_MS - (Date.now() - t0))
  if (hideTimer != null) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  hideTimer = setTimeout(() => {
    hideTimer = null
    hideUdvSplash()
  }, wait)
}

/** @internal tests */
export function _resetSplashGateForTests() {
  shellGateActive = false
  clearSafetyTimer()
  if (hideTimer != null) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
}

/** @internal tests */
export function _isSplashShellGateActive() {
  return shellGateActive
}
